import React from "react";
import { List } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQrcode } from "@fortawesome/free-solid-svg-icons";
import { UI_COLORS } from "../../config";
import { normalizeKeyId, normalizeValueText } from "./KeysList.utils";

/**
 * KeyItem: small component that renders a single List.Item for KeysList
 */
export default React.memo(function KeyItem({ item, selectedKey, onKeySelect }) {
  const keyId = normalizeKeyId(item);
  const valueText = normalizeValueText(item);

  return (
    <List.Item
      key={keyId || JSON.stringify(item)}
      onClick={() => onKeySelect?.(keyId)}
      style={{
        cursor: "pointer",
        backgroundColor: selectedKey === keyId ? "#EBF1FA" : "white",
        padding: 0,
        margin: 0,
        borderBottom: "1px solid #f0f0f0",
      }}
      className="hover:bg-gray-50"
    >
      <List.Item.Meta
        style={{ height: 60, display: "flex", alignItems: "center" }}
        avatar={<FontAwesomeIcon icon={faQrcode} style={{ fontSize: 24, color: UI_COLORS.primary }} />}
        title={<div className="whitespace-nowrap text-base text-gray-900 w-full">{String(keyId)}</div>}
        description={<div className="text-sm text-gray-500 w-full truncate">{valueText}</div>}
      />
    </List.Item>
  );
});